import {
  AttributeOptions,
  FNOL_RequestForm,
  MultiSelectOption,
} from '@dispatch/shared/types';
import { SelectField } from '@dispatch/web/ui';
import { Grid } from '@mui/material';
import {
  Control,
  FieldValues,
  UseFieldArrayAppend,
  UseFormWatch,
} from 'react-hook-form';
import {
  buildClaimAttributeRow,
  getAddableAttributeOptions,
} from '../pinnedClaimAttributes';

export type FNOLClaimAttributesAddProps = {
  append: UseFieldArrayAppend<FieldValues, 'claimAttributes'>;
  control: Control<FieldValues>;
  watch: UseFormWatch<FNOL_RequestForm>;
  companyAttributes: AttributeOptions[];
  /** Excluded from the options; nothing renders while undefined (resolving). */
  pinnedAttributeGuids: readonly string[] | undefined;
};

export function FNOLClaimAttributesAdd({
  append,
  control,
  watch,
  companyAttributes,
  pinnedAttributeGuids,
}: FNOLClaimAttributesAddProps) {
  const handleAddClaimAttributes = (
    value: MultiSelectOption | (string | number)[] | null
  ) => {
    if (!value || Array.isArray(value)) return;

    const selectedAttribute = companyAttributes.find(
      (attribute) => attribute.value === value.value
    );

    append(buildClaimAttributeRow(selectedAttribute));
  };

  if (!pinnedAttributeGuids) {
    return null;
  }

  return (
    <div
      style={{
        padding: '24px',
      }}
    >
      <Grid container rowSpacing={4} spacing={2}>
        <Grid size={6}>
          <SelectField
            id="addSelectedAttributeGUID"
            name="addSelectedAttributeGUID"
            label="Add New Attribute"
            control={control}
            onValueChange={handleAddClaimAttributes}
            options={getAddableAttributeOptions(
              companyAttributes,
              watch('claimAttributes'),
              pinnedAttributeGuids
            )}
          />
        </Grid>
      </Grid>
    </div>
  );
}
